import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IAccountStatementRequest } from '@app/shared/models/banking.model';
import { AccountBasicService } from '@app/shared/services/banking/account-basic.service';
import { AccountContext } from '@app/shared/services/context/account.context.service';
import { CustomerContext } from '@app/shared/services/context/customer.context.service';
import { ValidateDateRange } from '@app/shared/utils/date-range.validator';
import moment from 'moment';
import { openFilePreview } from '@app/shared/utils/file-preview';
import { AmplitudeService } from '@app/shared/services/amplitude.service';
import { ACTION_EVENT_PROPERTY, ACTION_NAME, AMPLITUDE_EVENT } from '@app/shared/types/enums/amplitude';
import { SubscriberComponent } from '@app/shared/modules/subscriber/base/subscriber.component.base';

@Component({
  selector: 'app-statement-acc',
  templateUrl: './statement-acc.component.html',
  styleUrls: ['./statement-acc.component.sass'],
})
export class StatementAccComponent extends SubscriberComponent implements OnInit {
  form!: FormGroup;
  isLoading = false;

  constructor(
    private readonly _accountBasicSvc: AccountBasicService,
    private readonly _accountCtx: AccountContext,
    private readonly _customerCtxSvc: CustomerContext,
    private readonly _amplitudeSvc: AmplitudeService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.logAmplitudeEvent();
  }

  private initForm() {
    const startOfMonth = moment().startOf('month').toDate();
    const today = new Date();
    //const lastMonth = moment(today).add(-1, 'M').toDate();
    this.form = new FormGroup(
      {
        from: new FormControl(startOfMonth, [Validators.required]),
        to: new FormControl(today, [Validators.required]),
      },
      {
        validators: [ValidateDateRange('from', 'to')],
      }
    );
  }

  showPreviewOnline() {
    this.isLoading = true;

    this._subscriptions.sink = this.getAccountStatement().subscribe(res => {
      openFilePreview(res?.file || '');
      this.isLoading = false;
    });
  }

  private getAccountStatement() {
    moment.locale('es');
    const rppUserId = this._customerCtxSvc.getRppUserId();
    const accountCode = this._accountCtx.getCurrentAccount()?.code || '';
    const { from, to } = this.form.value;

    const formatPeriod = (date: Date) =>
      moment(date).format('DD MMMM').replace(/ (\w)/, match => match.toUpperCase());

    const request: IAccountStatementRequest = {
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
      period: `${formatPeriod(from)}-${formatPeriod(to)}`,
    };

    return this._accountBasicSvc.getAccountStatement(rppUserId, accountCode, request);
  }

  private logAmplitudeEvent() {
    this._amplitudeSvc.logEvent<ACTION_EVENT_PROPERTY>(AMPLITUDE_EVENT.ACTION_INIT, {
      actionName: ACTION_NAME.ACCOUNT_STATEMENT,
    });
  }
}
